import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=0a44a860&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./common.scss?vue&type=style&index=0&id=0a44a860&prod&lang=scss&scoped=true&"
import style1 from "./RegisterForm.vue?vue&type=style&index=1&id=0a44a860&prod&lang=scss&scoped=true&"
import style2 from "./RegisterForm.vue?vue&type=style&index=2&id=0a44a860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44a860",
  null
  
)

export default component.exports